import axios from "axios";
let baseURL = "";
if (process.env.NODE_ENV == 'development') {//开发环境
    baseURL = '/api/web/auth/accessAuth/getAppTokenByHosts';
} else if (process.env.NODE_ENV == 'production') {//生产环境
    baseURL = '/web/auth/accessAuth/getAppTokenByHosts';
}
// let baseUrl = "/api/web/auth/accessAuth/getAppTokenByHosts";
//获取token
export function getTokens() {
    return axios.post(baseURL, {
        actionType: "getAppTokenByHosts", //固定写法就行
        actionBody: {}
    });
}